<template>
  <div class="uk-card uk-card-default uk-card-body uk-card-hover">
    <div
      class="uk-card-header uk-padding-small uk-padding-remove-left uk-padding-remove-bottom"
    >
      <div class="uk-card-badge uk-label" v-html="label"></div>
      <div class="uk-width-expand uk-margin-small-top">
        <h3 class="uk-card-title uk-margin-remove-bottom uk-text-bold">
          <a :href="link" target="_blank" v-html="name"></a>
        </h3>
        <p
          class="uk-text-meta uk-text-bold uk-margin-remove-top"
          v-html="msg"
        ></p>
      </div>
    </div>
    <div
      class="uk-card uk-card-body uk-padding-small uk-padding-remove-left uk-padding-remove-bottom"
    >
      <dl
        class="uk-description-list"
        v-for="item in items"
        v-bind:key="item.id"
      >
        <dt v-html="item.topic"></dt>
        <dd v-html="item.points"></dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfileCard",
  props: {
    name: String,
    label: String,
    msg: String,
    link: String,
    items: Array,
  },
};
</script>

<style scoped>
dd {
  font-family: "overpass", sans-serif;
  font-weight: 700;
  font-style: normal;
  margin-top: 8px;
}
</style>
